'use strict';

angular.module('DoohApps').service('AppAdminBLL', ['AppAdmin', 'UploadFileStorage', 'FileDownloadHelper',
    function (AppAdmin, UploadFileStorage, FileDownloadHelper) {
        this.checkAppVerBeforeDelete = function (callback, appId) {
            AppAdmin.checkAppVerBeforeDelete(function (data) { callback(data) }, appId);
        }

        this.deleteAppVersion = function (callback, verId) {
            AppAdmin.deleteAppVersion(function (data) { callback(data) }, verId);
        }

        this.GetApps = function (callback, objectFilterOptions) {
            AppAdmin.getApps(function (data) { callback(data) }, objectFilterOptions);
        }

        function returnContent(callback, data) {
            callback(data.Data.Content);
        }

        function responseHandler(callback, data) {
            callback({
                hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: getErrorMessage(data),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
            });
        }

        function getErrorMessage(data) {
            if (data.hasError)
                return data.errors[0];

            return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
        }

        this.getLicensesForAppAdmin = function (callback, filter) {
            AppAdmin.getLicensesForAppAdmin(function (data) { responseHandler(callback, data) }, filter);
        }

        this.getAppVersionListByAppId = function (callback, appId) {
            AppAdmin.getAppVersionListByAppId(function (data) {
                responseHandler(callback, data)
            }, appId);
        }

        this.GetAppByIdAdmin = function (callback, id, verId) {
            AppAdmin.getAppByIdAdmin(callback, id, verId);
        }

        this.UpdateApp = function (callback, app) {
            AppAdmin.updateApp(function (data) { responseHandler(callback, data) }, app);
        }

        this.AddNewApp = function (callback, app) {
            AppAdmin.addApp(function (data) { callback(data) }, app);
        }

        this.checkAppBeforeDelete = function (callback, appId) {
            AppAdmin.checkAppBeforeDelete(function (data) { callback(data) }, appId);
        }
        this.deleteApp = function (callback, Id) {
            AppAdmin.deleteApp(function (data) { callback(data) }, Id);
        }
        this.GetVersionFiles = function (callback, version) {
            AppAdmin.GetVersionFiles(function (data) { responseHandler(callback, data) }, version);
        }

        this.UpdateVersionFile = function (callback, versionFile) {
            AppAdmin.UpdateVersionFile(function (data) { responseHandler(callback, data) }, versionFile);
        }

        this.CheckAppVersionFile = function (callback, fileid) {
            AppAdmin.CheckAppVersionFile(function (data) { responseHandler(callback, data) }, fileid);
        }

        this.DeleteVersionFile = function (callback, fileID, versionID) {
            AppAdmin.DeleteVersionFile(function (data) { responseHandler(callback, data) }, fileID, versionID);
        }

        this.GetExistingVersionFiles = function (callback, ExistingVersionFiles) {
            AppAdmin.GetExistingVersionFiles(function (data) { responseHandler(callback, data) }, ExistingVersionFiles);
        }

        this.AddExistingVersionFiles = function (callback, files) {
            AppAdmin.AddExistingVersionFiles(function (data) { responseHandler(callback, data) }, files);
        }

        this.AddNewVersionFile = function (callback, file) {
            AppAdmin.AddNewVersionFile(function (data) { responseHandler(callback, data) }, file);
        }

        this.getExecutableActions = function (callback, verID) {
            AppAdmin.getExecutableActions(function (data) { responseHandler(callback, data) }, verID);
        }

        this.AddExecutableAction = function (callback, VerExeAction) {
            AppAdmin.AddExecutableAction(function (data) { responseHandler(callback, data) }, VerExeAction);
        }

        this.updateExecutableAction = function (callback, VerExeAction) {
            AppAdmin.updateExecutableAction(function (data) { responseHandler(callback, data) }, VerExeAction);
        }

        this.deleteExecutableAction = function (callback, id) {
            AppAdmin.deleteExecutableAction(function (data) { responseHandler(callback, data) }, id);
        }

        this.getRequirementTypes = function (callback) {
            AppAdmin.getRequirementTypes(function (data) { returnContent(callback, data) });
        }

        this.addRemoveRequirements = function (callback, requirements) {
            AppAdmin.addRemoveAppRequirements(function (data) { callback(data) }, requirements);
        }

        this.updateAppImages = function (callback, appData) {
            AppAdmin.updateAppImages(function (data) { callback(data) }, appData);
        }

        this.updateAppVersion = function (callback, appVer) {
            AppAdmin.updateAppVersion(function (data) { responseHandler(callback, data) }, appVer);
        }

        this.addAppVersion = function (callback, appversion) {
            AppAdmin.addAppVersion(function (data) { responseHandler(callback, data) }, appversion);
        }
        this.ExportSettings = function (callback, exportOptions) {
            AppAdmin.ExportSettings(function (data) { callback(data) }, exportOptions);
        }
        this.ImportSettings = function (callback, importOptions) {
            AppAdmin.ImportSettings(function (data) { callback(data) }, importOptions);
        }
        this.ResolveImportConflict = function (callback, resolve) {
            AppAdmin.resolveImportConflict(function (data) { callback(data) }, resolve);
        }
        this.copyApplication = function (callback, appData) {
            AppAdmin.copyApplication(function (data) { callback(data) }, appData);
        }
        this.GetAllApps = function (callback) {
            AppAdmin.getAllApps(function (data) { returnContent(callback, data) });
        }

        this.saveConfiguratorBlocks = function (callback, blocks) {
            AppAdmin.saveConfiguratorBlocks(function (data) { responseHandler(callback, data) }, blocks);
        }

        this.getCustomCode = function (callback, data) {
            AppAdmin.getCustomCode(function (data) {
                responseHandler(callback, data)
            }, data);
        }

        this.saveCustomCode = function (callback, data) {
            AppAdmin.saveCustomCode(function (data) {
                responseHandler(callback, data)
            }, data);
        }

        this.copyVersion = function (callback, appData) {
            AppAdmin.copyVersion(function (data) { callback(data) }, appData);
        }

        this.moveAssets = function (callback, data) {
            AppAdmin.moveAssets(function (data) {
                responseHandler(callback, data)
            }, data);
        }

        this.getFileUrl = function (fileID) {
            AppAdmin.getFileUrl(function (data) {
                responseHandler(FileDownloadHelper.downloadFileFromResponse, data);
            }, fileID);
        }
    }]);